import { useRef, useState } from 'react'
import { Box, Grid, IconButton, Typography } from '@mui/material'
import Link from 'next/link'

import { CustomEventName } from '@ecm/data/Analytics'
import { runClientEff } from '@ecm/effect'
import Button from '@ecm/ui/element/Button'
import Color from '@ecm/ui/element/Color'
import useIntersectionObserver from '@ecm/ui/hook/UseIntersectionObserver'

type StickyBannerProps = {
  trackingId: string
  eventName: CustomEventName
}

const StickyBanner = ({ trackingId, eventName }: StickyBannerProps) => {
  const [stickyPosition, setStickyPosition] = useState(true)
  const [isPinned, setIsPinned] = useState(false)
  const containerRef = useRef(null)

  const onSignupBtnClick = () => {
    runClientEff(eff => {
      eff.trackGa({ event: eventName })
    })
  }

  useIntersectionObserver(containerRef, ([e]) => setIsPinned(e.intersectionRatio === 1), {
    threshold: [1],
  })

  return (
    <Grid
      container
      sx={{
        '& > p': {
          mb: { sm: 0 },
          mr: { md: '2em', sm: '1em' },
          mt: 0,
        },
        alignItems: 'center',
        background: 'linear-gradient(273.02deg, #4EDF97 -4.11%, #0F2272 100%)',
        bottom: '-1px',
        flexDirection: { sm: 'row', xs: 'column' },
        height: { sm: '4em', xs: '6em' },
        justifyContent: 'center',
        position: stickyPosition ? 'sticky' : 'static',
        py: '0.5em',
      }}
      ref={containerRef}
    >
      <Typography variant="p3" fontWeight={700} color={Color.white.normal}>
        Virtual Mailbox for you!
      </Typography>

      <Box
        id={trackingId}
        sx={{
          '& > button': { height: '40px', margin: '0', p: '0 3em' },
        }}
      >
        <Link passHref href="/pricing">
          <Button onClick={onSignupBtnClick} white>
            Check Our Offer!
          </Button>
        </Link>
      </Box>
      {stickyPosition && !isPinned && (
        <IconButton
          sx={{
            color: 'white',
            fontSize: { sm: '30px', xs: '25px' },
            padding: '0 !important',
            position: 'absolute',
            right: '2%',
            top: { sm: '25%', xs: '5%' },
          }}
          onClick={() => setStickyPosition(false)}
        >
          &#x2715;
        </IconButton>
      )}
    </Grid>
  )
}

export default StickyBanner
